/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/id_card'
export default icon
